import React from 'react'
import { Route } from 'react-router'
import AppDetail from '@/modules/apps/components/app-detail'
import AppsList from '@/modules/apps/components/apps-list'
import AppNew from '@/modules/apps/components/app-new'
import AppEdit from '@/modules/apps/components/app-edit'
import AppDashboard from '@/modules/apps/components/app-dashboard'
import AddisonView from '@/modules/apps/own/addison/components/addison-view'
import DatevView from './own/datev/components/datev-view'
import MiteView from './own/mite/components/tracking-list'
import CleverreachWrapper from './own/cleverreach/components/cleverreach-wrapper'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const appsRoutes = (
  <>
    <Route path='app/*' element={<RedirectToPlural />} />
    <Route path="apps/developer/dashboard" Component={AppDashboard} />
    <Route path='apps/:filter' Component={AppsList} />
    <Route path='apps' Component={AppsList} handle={{ title: 'Marktplatz' }} />
    <Route path='apps/new' Component={AppNew} />
    <Route path='apps/edit/:id/:version' Component={AppEdit} />
    <Route path='apps/:filter/show/:id' Component={AppDetail} />

    <Route path='apps/addison/:appId' Component={AddisonView} />

    <Route path='apps/datev/:appId' Component={DatevView} />
    <Route path='apps/mite/:appId' Component={MiteView} />
    <Route path='mite/:appId' Component={MiteView} />

    <Route path='cleverreach/:appId' Component={CleverreachWrapper} />
    <Route path='cleverreach/:appId(?cleverreach=:cleverreach)' Component={CleverreachWrapper} />
    <Route path='cleverreach(?code=:code)' Component={CleverreachWrapper} />
  </>
)

export default appsRoutes
